<div
  class="reservation-bar"
  [class.is-inquiry]="isInquiry"
  [class.is-hold]="isHold"
  [class.continues-left]="continuesLeft"
  [class.continues-right]="continuesRight"
  [class.no-label]="!showLabel"
  [matMenuTriggerFor]="popoverMenu"
  (click)="onBarClick($event)"
  (mouseenter)="onBarMouseEnter()"
  (mouseleave)="onBarMouseLeave()">
  @if (showLabel) {
    @if (logoUrl) {
      <span class="bar-logo-wrap">
        <img class="bar-logo" [src]="logoUrl" alt="" (error)="onLogoError()" />
      </span>
    }
    <span class="bar-label">{{ label }}</span>
    @if (continuesRight) {
      <span class="bar-arrow">›</span>
    }
  }
</div>

<mat-menu
  #popoverMenu="matMenu"
  class="reservation-popover-menu"
  xPosition="after"
  [hasBackdrop]="!isDesktop">
  <!-- Lazy so each popover's lock-code lookup runs only when it opens. -->
  <ng-template matMenuContent>
    <app-reservation-popover
      [reservation]="reservation"
      [address]="address"
      [addressId]="addressId"
      (guidebookClick)="handleGuidebookFromPopover()"
      (detailsClick)="handleDetailsFromPopover()"
      (messageClick)="handleMessageFromPopover()"
      (hoverChange)="onPopoverHoverChange($event)" />
  </ng-template>
</mat-menu>
